import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import ClanRoomChannel from 'channels/clan'

import LoadingScreen from 'components/LoadingScreen/LoadingScreen.jsx'

import requestAccountInfo from 'state/actions/account'

import { getReactiveUpdateUrl } from 'helpers/reactivity'

export class AuthWrapper extends React.Component {
    static propTypes = {
        showLoading: PropTypes.bool.isRequired,
        requestAccountInfo: PropTypes.func.isRequired,
        reactiveUrl: PropTypes.string,
    }
    componentWillMount() {
        this.props.requestAccountInfo()
    }
    componentWillUnmount() {
        this.closeReactiveConnection()
    }
    componentWillReceiveProps(nextProps) {
        // PushStream disabled - just do nothing
        if (!nextProps.reactiveUrl) return this.closeReactiveConnection()

        // If reactiveChannel changed, we should reconnect to new WebSocket
        if (nextProps.reactiveUrl && this.props.reactiveUrl !== nextProps.reactiveUrl) {
            return this.updateReactiveConnection(nextProps)
        }
    }
    updateReactiveConnection(props) {
        this.closeReactiveConnection()

        if (props === null) props = this.props

        const { reactiveUrl } = props
        if (reactiveUrl === null) {
            return
        }

        this.channel = new ClanRoomChannel(reactiveUrl)
    }
    closeReactiveConnection() {
        if (this.channel !== undefined){
            this.channel.disconnect()
            this.channel = undefined
        }
    }
    render() {
        if (this.props.showLoading) {
            return <LoadingScreen type='fullscreen' />
        }
        return this.props.children
    }
}

export const mapStateToProps = ({ account, clan, settings }) => {
    const showLoading = ((account.loaded !== account.loading) && account.loading) || !account.loaded

    const { reactive_channel } = clan
    const { pushStreamHost } = settings

    const reactiveUrl = getReactiveUpdateUrl(pushStreamHost, reactive_channel)

    return {
        showLoading,
        reactiveUrl,
    }
}

export const mapDispatchToProps = {
    requestAccountInfo,
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthWrapper)



// WEBPACK FOOTER //
// ./containers/AuthWrapper/AuthWrapper.jsx